<ng-container [ngSwitch]="useLegacy">
  <div *ngSwitchCase="true" class="legacy-logo">
    <img class="spinner" src="/assets/images/icons/legacy_logo_spinner.png" />
    <img src="/assets/images/icons/legacy_logo.png" />
  </div>

  <div
    *ngSwitchDefault
    class="icon"
    loadChild="/assets/images/icons/svg/ecaps_logo.svg"
  ></div>
</ng-container>
<span class="text">{{ text }}</span>
